import { create } from "zustand";

/** The active room's rail-law arithmetic, published for the shell's top row. */
export interface RailLawView {
  readonly open: number;
  readonly total: number;
  readonly budget: number;
  readonly fit: number;
  readonly stageWidth: number | null;
  readonly railCap: number;
}

interface RailLawState {
  readonly view: RailLawView | null;
  readonly setCap: ((cap: number) => void) | null;
  publish: (view: RailLawView, setCap: (cap: number) => void) => void;
  clear: () => void;
}

/**
 * One seat for the rail law in the shell's top row (principal directive
 * 2026-08-28, superseding the root-strip seat): exactly one room is active
 * at a time, and it publishes its fold arithmetic here; with no seated room
 * the row shows nothing. The cap verb flows back through the same seam, so
 * the control stays the room's — only its chair moved.
 */
export const useRailLawStore = create<RailLawState>((set) => ({
  view: null,
  setCap: null,
  publish: (view, setCap) => set({ view, setCap }),
  clear: () => set({ view: null, setCap: null }),
}));
